/**
 * Created by or_p on 7/26/2016.
 */
import _ from 'lodash';
import * as Colors from 'material-ui/styles/colors';


const borderProps = ['borderWidth', 'borderStyle', 'borderColor'];
function isEmptyBorderSetter(compProps) {
  const {borderWidth, borderStyle} = compProps;
  if (!_.isNil(borderWidth) && parseInt(borderWidth, 10) === 0) {
    return true;
  }
  if (borderStyle === null || borderStyle && borderStyle.toLowerCase() === 'none') {
    return true;
  }
}

export function getFixedBorderStyle(element, elementUpdate) {
  const {compProps} = elementUpdate;
  if (element && _.some(_.keys(compProps), prop => borderProps.indexOf(prop) !== -1)) {
    if (!isEmptyBorderSetter(compProps)) {
      const newCompProps = _.merge({}, element.compProps, compProps);
      const additionalCompProps = {};
      if (!newCompProps.borderColor) {
        additionalCompProps.borderColor = Colors.grey700;
      }
      if (!newCompProps.borderWidth || parseInt(newCompProps.borderWidth, 10) === 0) {
        additionalCompProps.borderWidth = 4;
      }
      if (_.isEmpty(newCompProps.borderStyle) || newCompProps.borderStyle.toLowerCase() === 'none') {
        additionalCompProps.borderStyle = 'solid';
      }
      return _.merge({}, _.cloneDeep(elementUpdate), {compProps: additionalCompProps});
    }
    return _.merge({}, _.cloneDeep(elementUpdate), {compProps: {borderWidth: 0, borderStyle: 'none'}});
  }
  return elementUpdate;
}
